/**
 *  Load modules
 */
import heroSwiper from './modules/heroSwiper.js';
import video from './modules/video.js';
import ResponsiveImages from './modules/responsiveImages.js';

// Initialize responsive images
new ResponsiveImages();

